
export class FFFightCard {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "FFFightCard";
    this.scene = "FFFightCard";
    this.data = [];
    this.page = 310;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml && options?.activeGames) {
      console.log(options?.activeGames)

      const games = options.activeGames;

      const countField =  xml.payload.field.find(item => item.attr.name === "00002");
      if (countField) countField.value = games.length.toString();

      games.forEach((game, i) => {
        const indexPrefix = (i + 1).toString().padStart(2,  '0');
        const nameFieldId = `${indexPrefix}01`;
        const resultFieldId = `${indexPrefix}04`;
        const homeName = `${game?.home_fighter?.first_name.toUpperCase()  || ""} ${game?.home_fighter?.last_name.toUpperCase()  || ""}`;
        const awayName = `${game?.away_fighter?.first_name.toUpperCase()  || ""} ${game?.away_fighter?.last_name.toUpperCase()  || ""}`;
        const nameField = xml.payload.field.find(item => item.attr.name === nameFieldId);
        const resultField = xml.payload.field.find(item => item.attr.name === resultFieldId);
        if (nameField) {
          if (game.completed === 0) {
            nameField.value = `${homeName} v ${awayName}`
          } else  if (game.completed === 1) {
            nameField.value = `${homeName} BEAT ${awayName}`
          } else  if (game.completed === 2) {
            nameField.value = `${awayName} BEAT ${homeName}`
          } 
        }
        if (resultField) {
          resultField.value = game?.winnerby || ""
        }
      });

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
